import FullscreenButton from './fullscreenButton'

export default FullscreenButton
